import { useFeatureFlagEnabled } from 'posthog-js/react'

export function useFeatureFlag(flagKey: string): boolean {
  // useFeatureFlagEnabled is reactive — re-renders when flags load or change.
  // Returns undefined while loading; default to false (disabled).
  return useFeatureFlagEnabled(flagKey) ?? false
}
